module.exports = __webpack_public_path__ + "static/media/award-symbol.5f1e4aec.png";